import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The one back arrow every document's own page uses (quotation, confirmed order, vendor PO, client
 * invoice, credit note), so the way back looks and behaves the same everywhere.
 *
 * It always goes to the module's LIST, named by the caller, never "one page back in the history": a page
 * reached from the sidebar's cycle has the previous document behind it, and history-back landed people
 * on the quotation instead of the list they were in.
 *
 * With `to` it is a real link (the caller may still intercept the click, e.g. to ask about unsaved edits);
 * with `onClick` alone it is a button.
 */
export interface BackArrowProps {
  /** Says where it goes, e.g. "Back to confirmed orders". Also the accessible name. */
  label: string;
  to?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const CLASS =
  'inline-flex items-center justify-center w-8 h-8 shrink-0 rounded-md border border-slate-300 bg-white text-slate-600 hover:bg-slate-50 touch-manipulation';

const BackArrow: React.FC<BackArrowProps> = ({ label, to, onClick }) =>
  to ? (
    <Link to={to} onClick={onClick} aria-label={label} title={label} className={CLASS}>
      <span aria-hidden="true">←</span>
    </Link>
  ) : (
    <button type="button" onClick={onClick} aria-label={label} title={label} className={CLASS}>
      <span aria-hidden="true">←</span>
    </button>
  );

export default BackArrow;
